<template>
  <div class="list-item-container gene-item">
    <div class="item-meta">
      <span class="meta-id">#{{ data._id}}</span>
      <span class="separator">›</span>
      <span class="meta-path">{{ data._source.locus_group }}</span>
    </div>

    <div class="item-header">
      <h3 class="title-left" @click="handleDetail">
        {{data._source.symbol}}
        <span class="sub-name">{{ data._source.name }}</span>
      </h3>

     <!--  <div class="status-group">
        <span class="status-badge approved" v-if="data._source.status === 'Approved'">{{ data._source.status }}</span>
      </div> -->
    </div>

    <div class="taxonomy-tags">
      <div class="tag-box">
        <span class="tag-label">HGNC ID</span>
        <span class="tag-val">{{ data._source.hgnc_id }}</span>
      </div>
      <div class="tag-box">
        <span class="tag-label">Location</span>
        <span class="tag-val">{{ data._source.location }}</span>
      </div>
      <div class="tag-box">
        <span class="tag-label">Ensembl</span>
        <span class="tag-val">{{ data._source.ensembl_gene_id }}</span>
      </div>
      <div class="tag-box">
        <span class="tag-label">Entrez ID</span>
        <span class="tag-val">{{ data._source.entrez_id }}</span>
      </div>
    </div>

    <div class="item-footer">
      <span class="footer-desc" v-if="data._source.gene_group?.length">
        归属于 <span class="highlight">{{ data._source.gene_group?.join(', ')}}</span> 的基因分组
      </span>
      <div class="alias-inline" v-if="data._source.alias_symbol?.length">
        <span class="alias-label">别名:</span>
        <span class="alias-text">{{ data._source.alias_symbol.join(', ') }}</span>
      </div>
    </div>
  </div>
</template>
<script setup>
  import { useRouter } from 'vue-router';

  const props = defineProps({
    data: { type: Object, required: true, default: () => ({}) }
  });

  const router = useRouter();

  const handleDetail = () => {
    console.log('查看详情:', props.data);
    router.push({
      path: '/genenames',
      query: { database_name: props.data._index, id: props.data._id }
    });
  };
</script>
<style scoped>
  .list-item-container {
    padding: 20px 0;
    background: transparent;
    cursor: pointer;
    transition: background 0.2s;
  }

  .list-item-container:hover .title-left {
    text-decoration: underline;
  }

  .item-meta {
    font-size: 13px;
    color: #70757a;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .item-header {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin: 0 0 4px 0;
  }

  .title-left {

    font-size: 20px;
    font-weight: 400;
    color: #1a0dab;
    cursor: pointer;
    display: flex;
    align-items: baseline;
    gap: 10px;
    font-weight: 600;
  }

  .main-symbol {
    font-size: 22px;
    color: #1a0dab;
    font-weight: 600;
    margin: 0;
    display: inline-block;
  }

  .sub-name {
    font-size: 14px;
    color: #70757a;
    font-style: italic;
    font-weight: normal;
    font-weight: 600;
  }

  .taxonomy-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-bottom: 12px;
  }

  .tag-box {
    background: #f8f9fa;
    padding: 2px 8px;
    border-radius: 4px;
    border: 1px solid #ebebeb;
    font-size: 12px;
  }

  .tag-label {
    color: #70757a;
    margin-right: 4px;
  }

  .tag-val {
    color: #202124;
    font-weight: 500;
  }

  .status-badge {
    font-size: 11px;
    padding: 2px 8px;
    border-radius: 4px;
    font-weight: 700;
    text-transform: uppercase;
  }

  .status-badge.approved {
    background: #e6f4ea;
    color: #1e8e3e;
  }

  .item-footer {
    font-size: 13px;
    color: #70757a;
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .alias-label {
    font-weight: 600;
    margin-right: 4px;
  }

  .alias-text {
    color: #5f6368;
  }

  .highlight {
    color: #1a0dab;
  }
</style>